var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 2C11.3136 2 13.9998 4.6865 14 8C13.9998 11.3135 11.3136 14 8 14C4.68652 13.9999 2.00024 11.3134 2 8C2.00024 4.68655 4.68652 2.00009 8 2ZM10.0928 6.55762C9.8485 6.33383 9.46899 6.3505 9.24512 6.59473L7.58887 8.40039L6.71973 7.59766C6.47625 7.37291 6.09684 7.38838 5.87207 7.63184C5.64733 7.87531 5.66184 8.25472 5.90527 8.47949L7.21777 9.69043C7.33497 9.79861 7.49104 9.85626 7.65039 9.84961C7.80961 9.84287 7.95969 9.77275 8.06738 9.65527L10.1299 7.40527C10.3537 7.161 10.337 6.78149 10.0928 6.55762Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark2);
export default __webpack_public_path__ + "static/media/Checkmark_2.341b1d871dc3f26bfc81652ec5005445.svg";
export { ForwardRef as ReactComponent };